
import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import InventorySettings from './InventorySettings';
import PriceSettings from './PriceSettings';
import ProductDetails from './ProductDetails';
import { DI, DIProps } from '../../../../../Core';
import { Navigate, Route, Routes } from 'react-router-dom';
import GlobalPriceAdjustment from './GlobalPriceAdjustment';
import { useTranslation } from 'react-i18next';

const ProductSettings = (props: DIProps) => {
    const { t } = useTranslation();
    const tabsArray = ['inventory', 'price', 'product', 'global_price']
    let tabForPath = tabsArray.indexOf(tabsArray.includes(props.match?.["*"] ?? 'inventory') ? props.match["*"] : 'inventory')
    const [selected, setSelected] = useState(tabForPath);
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 991);
        };

        window.addEventListener('resize', handleResize);

        // Clean up the event listener
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const tabs = [
        {
            key: 'inventory',
            id: 'inventory',
            label: t('Inventory'),
            children: <>
                <InventorySettings />
            </>,
        },
        {
            key: 'price',
            id: 'price',
            label: t('Price'),
            children: <>
                <PriceSettings />
            </>,
        },
        {
            key: 'product',
            id: 'product',
            label: t('Product Details'),
            children: <>
                <ProductDetails />
            </>,
        },
        ...props?.redux?.current?.source?.currency?.toUpperCase() != props?.redux?.current?.target?.currency?.toUpperCase() ? [{
            key: 'global_price',
            id: "global_price",
            label: t('Global Price Adjustments'),
            children: <>
                <GlobalPriceAdjustment />
            </>
        }] : [],
    ];

    useEffect(() => {
        setSelected(tabForPath)
    }, [tabForPath])

    return (
        <div className='Custom__Vertical--Tab'>
            <Tabs
                tabPosition={isSmallScreen ? "top" : "left"}
                onChange={(e) => { setSelected(tabsArray.indexOf(e)); props.history(e) }}
                items={tabs}
                activeKey={tabsArray[selected]}
                destroyInactiveTabPane
            />
            <Routes>
                <Route path={tabsArray[selected]} element={<></>} />
                <Route path='*' element={<Navigate to={'inventory'} />} />
            </Routes>
        </div>
    );
}


export default DI(ProductSettings);